import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';
import { IconButtonComponent, TooltipDirective } from '@mode/capra';
import { ColorTarget } from '@mode-vegas/vegas';

@Component({
  standalone: true,
  selector: 'mode-background-settings-toggle',
  imports: [CommonModule, IconButtonComponent, TooltipDirective],
  templateUrl: './background-settings-toggle.component.html',
  styleUrls: ['./background-settings-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackgroundSettingsToggleComponent {
  @Input() showTextSettings = false;
  @Input() enableTextSettings = false;
  @Input() isUseAsBackground = false;

  @Output() markTargetUpdated = new EventEmitter<ColorTarget>();

  onMarkTargetClick(target: ColorTarget) {
    this.markTargetUpdated.emit(target);
  }
}
